import { Grid } from '@material-ui/core';
import React from 'react';
import FilterTogglebar from './FilterTogglebar';
import CentralArizonaView from './CentralArizonaView';
import CentralArizonaViewResponsive from './CentralArizonaViewResponsive';
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';

const CentralArizonaContainer = () => {
    const { isMobile } = useGetViewPortDimensions();

    return (
        <Grid container>
            {!isMobile ? <FilterTogglebar /> : null}
            {!isMobile ? <CentralArizonaView /> : <CentralArizonaViewResponsive />}
        </Grid>
    );
};

export default CentralArizonaContainer;